// removed by extract-text-webpack-plugin
module.exports = {"text800":"_16Tsa3GWSu_UDSz5FuHkZg","text700":"_2L-LiTIw2FnDLP0HxoNxQt","text600":"_1UDmwTBx2Nz12B6Oj2i0Bw","text500":"_2eTeyxfSXwer86hnXLAvVT","text400":"_24V-QZDGq-CN5y-riH9Ukz","text300":"_1sTP7Ek3CCr_fL7EPXf8cv","text200":"_3kv6aTYs1Y5nQEKvtqVmq-","textParagraph":"S1g_U06SpYSqHD5oxKGbY","crimp":"_3_Jf7P-1Ou31z7Kdp3-MgN","trim":"pQdX18DCiYOkSKRkqJ3Mu","flexCenter":"XFO8B96Zt5ngab0Ux6t6M","hideTextOverflow":"_3R8BDdzwhkTMMNLgvFdqiz","marginPageMainContent":"_2Qm444_DqX5Y3B-xvEaBm1","actionButton":"_3q8tcbwGzPd3WrXwj8ffva","button":"_3oL4WHdD6H4H70x3L2Ljt2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/forms/ButtonCancel.scss
// module id = 1168
// module chunks = 0